<template>
  <div class="customTag-container" :style="{color, fontSize: fontSize + 'px'}">
    <span class="tag" :style="{background: color}"></span>{{ text }}
  </div>
</template>

<script>
export default {
  name: 'CustomTag',
  props: {
    text: {
      type: String
    },
    color: {
      type: String
    },
    fontSize: {
      type: Number,
      default: 12
    }
  }
}
</script>

<style lang="less" scoped>
.customTag-container {
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 10px;
  font-size: 12px;
  & > .tag {
    position: absolute;
    left: 0;
    top: 7px;
    display: block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }
}
</style>
